import React from 'react'
import './About.css'



export default function About() {
    return (
        <div className='about_component'>
            <img src='/hackathon_image.png' className='hackathon_image' alt='hackathon'></img>
            <div className='aboutContent'>
                <p className='hackathonMainName'>HOSPITALITY POWER BI CHALLENGE</p>
                <p className='about_text'>ABOUT THE CHALLENGE</p>
                <p className='hackathon_description' style={{ marginBottom: "0px" }}>
                    This exciting challenge invites participants to explore real-world hospitality datasets covering hotel operations, bookings, finance, guest feedback, and revenue performance across multiple properties and cities. Analyze trends in occupancy, ADR, RevPAR, customer satisfaction, booking channels, loyalty programs, and profitability using Power BI. 
                </p>

                <p className='hackathon_description' style={{ marginTop: "-5px" }}>Build compelling, interactive dashboards that uncover what drives hotel success—from guest experience and operational efficiency to revenue optimization and business growth. Whether you're a seasoned BI professional or an aspiring data analyst, this is your opportunity to showcase your analytical skills, deliver impactful insights, and make your mark in the world of hospitality analytics!</p>
            </div>
        </div>
    )
}
